// Comprehensive reward templates for Chore Haven
export const rewardTemplates = {
  // Screen Time & Technology (15-60 points)
  screenTime: [
    {
      title: "Extra 30 Minutes Screen Time",
      description: "Enjoy 30 extra minutes on your favorite device",
      points: 25,
      emoji: "📱",
      category: "technology",
      ageGroup: "all"
    },
    {
      title: "Extra Hour Screen Time",
      description: "Get a full extra hour for games, videos, or apps",
      points: 50,
      emoji: "📺",
      category: "technology",
      ageGroup: "all"
    },
    {
      title: "Pick Tonight's Movie",
      description: "Choose what the whole family watches tonight",
      points: 35,
      emoji: "🎬",
      category: "entertainment",
      ageGroup: "all"
    },
    {
      title: "Video Game Tournament",
      description: "Host a family video game tournament",
      points: 60,
      emoji: "🎮",
      category: "technology",
      ageGroup: "8+"
    },
    {
      title: "YouTube Time",
      description: "Watch your favorite YouTube videos for an hour",
      points: 30,
      emoji: "📺",
      category: "technology",
      ageGroup: "6+"
    },
    {
      title: "New App Download",
      description: "Download a new game or app of your choice",
      points: 40,
      emoji: "📲",
      category: "technology",
      ageGroup: "8+"
    }
  ],

  // Food & Treats (20-80 points)
  food: [
    {
      title: "Ice Cream Trip",
      description: "Special trip to get your favorite ice cream",
      points: 50,
      emoji: "🍦",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Choose Tonight's Dinner",
      description: "Pick what the family has for dinner",
      points: 30,
      emoji: "🍕",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Bake Cookies Together",
      description: "Spend time baking your favorite cookies",
      points: 45,
      emoji: "🍪",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Special Dessert",
      description: "Get your favorite dessert after dinner",
      points: 25,
      emoji: "🧁",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Restaurant Choice",
      description: "Pick where the family goes out to eat",
      points: 75,
      emoji: "🍽️",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Pizza Party",
      description: "Have a personal pizza party with your favorite toppings",
      points: 60,
      emoji: "🍕",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Candy Store Visit",
      description: "Pick out $5 worth of candy at the store",
      points: 40,
      emoji: "🍭",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Hot Chocolate Bar",
      description: "Make hot chocolate with all your favorite toppings",
      points: 20,
      emoji: "☕",
      category: "food",
      ageGroup: "all"
    }
  ],

  // Activities & Outings (40-150 points)
  activities: [
    {
      title: "Park Adventure",
      description: "Special trip to your favorite park or playground",
      points: 40,
      emoji: "🏞️",
      category: "outdoor",
      ageGroup: "all"
    },
    {
      title: "Movie Theater Trip",
      description: "Go see a movie at the theater with popcorn",
      points: 100,
      emoji: "🎭",
      category: "entertainment",
      ageGroup: "all"
    },
    {
      title: "Mini Golf",
      description: "Play a round of mini golf",
      points: 80,
      emoji: "⛳",
      category: "outdoor",
      ageGroup: "6+"
    },
    {
      title: "Bowling Night",
      description: "Go bowling with the family",
      points: 90,
      emoji: "🎳",
      category: "entertainment",
      ageGroup: "6+"
    },
    {
      title: "Zoo or Aquarium Visit",
      description: "Special trip to see animals",
      points: 150,
      emoji: "🦁",
      category: "educational",
      ageGroup: "all"
    },
    {
      title: "Arcade Fun",
      description: "Play games at the arcade with tokens",
      points: 75,
      emoji: "🕹️",
      category: "entertainment",
      ageGroup: "6+"
    },
    {
      title: "Beach Day",
      description: "Spend a day at the beach or lake",
      points: 120,
      emoji: "🏖️",
      category: "outdoor",
      ageGroup: "all"
    },
    {
      title: "Trampoline Park",
      description: "Jump and play at a trampoline park",
      points: 85,
      emoji: "🤸",
      category: "physical",
      ageGroup: "5+"
    }
  ],

  // Social & Friends (50-120 points)
  social: [
    {
      title: "Friend Sleepover",
      description: "Have a friend over for a sleepover",
      points: 100,
      emoji: "🏠",
      category: "social",
      ageGroup: "6+"
    },
    {
      title: "Friend Playdate",
      description: "Invite a friend over to play",
      points: 50,
      emoji: "👫",
      category: "social",
      ageGroup: "all"
    },
    {
      title: "Birthday Party Friend",
      description: "Bring an extra friend to a birthday party",
      points: 80,
      emoji: "🎉",
      category: "social",
      ageGroup: "5+"
    },
    {
      title: "Video Call with Grandparents",
      description: "Special video call time with grandparents",
      points: 30,
      emoji: "👵",
      category: "social",
      ageGroup: "all"
    },
    {
      title: "Friend Adventure",
      description: "Plan a special activity with your best friend",
      points: 120,
      emoji: "🎯",
      category: "social",
      ageGroup: "8+"
    }
  ],

  // Privileges & Special Treatment (15-100 points)
  privileges: [
    {
      title: "Stay Up 30 Minutes Late",
      description: "Get to stay up 30 minutes past bedtime",
      points: 40,
      emoji: "🌙",
      category: "privilege",
      ageGroup: "all"
    },
    {
      title: "Stay Up 1 Hour Late",
      description: "Stay up a full hour past your normal bedtime",
      points: 70,
      emoji: "⭐",
      category: "privilege",
      ageGroup: "all"
    },
    {
      title: "Skip One Chore",
      description: "Skip your least favorite chore for the week",
      points: 35,
      emoji: "🎈",
      category: "privilege",
      ageGroup: "all"
    },
    {
      title: "Be Parent's Helper",
      description: "Help parent with a special grown-up task",
      points: 25,
      emoji: "👨‍👩‍👧‍👦",
      category: "privilege",
      ageGroup: "5+"
    },
    {
      title: "Choose Family Activity",
      description: "Pick what the whole family does this weekend",
      points: 60,
      emoji: "🎪",
      category: "privilege",
      ageGroup: "6+"
    },
    {
      title: "No Homework Day",
      description: "Take a break from homework for one day (with parent approval)",
      points: 80,
      emoji: "📚",
      category: "privilege",
      ageGroup: "6+"
    },
    {
      title: "Special Breakfast",
      description: "Get your favorite breakfast made just for you",
      points: 20,
      emoji: "🥞",
      category: "food",
      ageGroup: "all"
    },
    {
      title: "Room Decoration",
      description: "Get to redecorate or add something new to your room",
      points: 100,
      emoji: "🏡",
      category: "privilege",
      ageGroup: "all"
    }
  ],

  // Toys & Shopping (30-200 points)
  shopping: [
    {
      title: "Small Toy ($5-10)",
      description: "Pick out a small toy or item at the store",
      points: 60,
      emoji: "🧸",
      category: "shopping",
      ageGroup: "all"
    },
    {
      title: "Medium Toy ($10-20)",
      description: "Choose a medium-sized toy or game",
      points: 120,
      emoji: "🎁",
      category: "shopping",
      ageGroup: "all"
    },
    {
      title: "Big Toy ($20-50)",
      description: "Get a special bigger toy or item",
      points: 200,
      emoji: "🎁",
      category: "shopping",
      ageGroup: "all"
    },
    {
      title: "Book Store Trip",
      description: "Pick out new books to read",
      points: 40,
      emoji: "📚",
      category: "educational",
      ageGroup: "all"
    },
    {
      title: "Art Supplies",
      description: "Get new art supplies for creative projects",
      points: 50,
      emoji: "🎨",
      category: "creative",
      ageGroup: "all"
    },
    {
      title: "Sports Equipment",
      description: "Get new sports gear or equipment",
      points: 80,
      emoji: "⚽",
      category: "physical",
      ageGroup: "5+"
    },
    {
      title: "Clothes Shopping",
      description: "Pick out a new outfit or clothes item",
      points: 70,
      emoji: "👕",
      category: "shopping",
      ageGroup: "8+"
    }
  ],

  // Creative & Learning (20-90 points)
  creative: [
    {
      title: "Art & Craft Time",
      description: "Dedicated time for your favorite art project",
      points: 30,
      emoji: "🎨",
      category: "creative",
      ageGroup: "all"
    },
    {
      title: "Science Experiment",
      description: "Do a fun science experiment together",
      points: 45,
      emoji: "🔬",
      category: "educational",
      ageGroup: "6+"
    },
    {
      title: "Music Lesson",
      description: "Extra music practice or lesson time",
      points: 40,
      emoji: "🎵",
      category: "creative",
      ageGroup: "all"
    },
    {
      title: "Build Something",
      description: "Work on a building project with blocks or Lego",
      points: 35,
      emoji: "🔨",
      category: "creative",
      ageGroup: "all"
    },
    {
      title: "Photography Adventure",
      description: "Take photos around the house or neighborhood",
      points: 50,
      emoji: "📸",
      category: "creative",
      ageGroup: "8+"
    },
    {
      title: "Cooking Lesson",
      description: "Learn to make your favorite recipe",
      points: 60,
      emoji: "👨‍🍳",
      category: "educational",
      ageGroup: "6+"
    },
    {
      title: "Garden Project",
      description: "Plant and care for your own small garden",
      points: 55,
      emoji: "🌱",
      category: "educational",
      ageGroup: "all"
    },
    {
      title: "Dance Party",
      description: "Have your own dance party with favorite music",
      points: 25,
      emoji: "💃",
      category: "physical",
      ageGroup: "all"
    }
  ],

  // Special Events & Celebrations (50-150 points)
  events: [
    {
      title: "Special Day Out",
      description: "Plan a whole day of your favorite activities",
      points: 150,
      emoji: "🎊",
      category: "special",
      ageGroup: "all"
    },
    {
      title: "Theme Park Visit",
      description: "Trip to an amusement or theme park",
      points: 200,
      emoji: "🎢",
      category: "entertainment",
      ageGroup: "all"
    },
    {
      title: "Museum Adventure",
      description: "Educational trip to a fun museum",
      points: 80,
      emoji: "🏛️",
      category: "educational",
      ageGroup: "6+"
    },
    {
      title: "Camping Night",
      description: "Backyard camping or indoor fort building",
      points: 90,
      emoji: "⛺",
      category: "adventure",
      ageGroup: "all"
    },
    {
      title: "Special Celebration",
      description: "Create a celebration just for your achievements",
      points: 100,
      emoji: "🎉",
      category: "special",
      ageGroup: "all"
    }
  ],

  // Physical Activities (25-80 points)
  physical: [
    {
      title: "Bike Ride Adventure",
      description: "Go on a special bike ride to a fun destination",
      points: 50,
      emoji: "🚴",
      category: "physical",
      ageGroup: "5+"
    },
    {
      title: "Swimming Trip",
      description: "Go swimming at a pool or water park",
      points: 70,
      emoji: "🏊",
      category: "physical",
      ageGroup: "all"
    },
    {
      title: "Sports Game",
      description: "Play your favorite sport with family",
      points: 40,
      emoji: "🏀",
      category: "physical",
      ageGroup: "all"
    },
    {
      title: "Hiking Adventure",
      description: "Go on a nature hike with snacks",
      points: 60,
      emoji: "🥾",
      category: "physical",
      ageGroup: "6+"
    },
    {
      title: "Playground Time",
      description: "Extended play time at your favorite playground",
      points: 30,
      emoji: "🛝",
      category: "physical",
      ageGroup: "all"
    },
    {
      title: "Sports Lesson",
      description: "Take a lesson in a sport you want to learn",
      points: 80,
      emoji: "🎾",
      category: "physical",
      ageGroup: "6+"
    }
  ]
}

// Quick reward suggestions by age group
export const rewardsByAge = {
  "3-5": [
    "Extra 30 Minutes Screen Time",
    "Special Dessert",
    "Small Toy ($5-10)",
    "Park Adventure",
    "Art & Craft Time",
    "Dance Party"
  ],
  "6-8": [
    "Ice Cream Trip",
    "Friend Playdate",
    "Stay Up 30 Minutes Late",
    "Choose Tonight's Dinner",
    "Book Store Trip",
    "Science Experiment"
  ],
  "9-12": [
    "Movie Theater Trip",
    "Friend Sleepover",
    "Video Game Tournament",
    "Mini Golf",
    "Medium Toy ($10-20)",
    "Cooking Lesson"
  ],
  "13+": [
    "Choose Family Activity",
    "Restaurant Choice",
    "Big Toy ($20-50)",
    "Theme Park Visit",
    "Clothes Shopping",
    "Special Day Out"
  ]
}

// Reward categories with point ranges
export const rewardCategories = {
  quick: {
    label: "Quick Rewards",
    pointRange: [15, 40],
    description: "Small treats and privileges",
    examples: ["Extra screen time", "Special snack", "Stay up late"]
  },
  medium: {
    label: "Medium Rewards", 
    pointRange: [40, 80],
    description: "Fun activities and outings",
    examples: ["Friend playdate", "Ice cream trip", "Art supplies"]
  },
  big: {
    label: "Big Rewards",
    pointRange: [80, 150],
    description: "Special adventures and experiences",
    examples: ["Movie theater", "Bowling", "Friend sleepover"]
  },
  mega: {
    label: "Mega Rewards",
    pointRange: [150, 300],
    description: "Ultimate experiences and big purchases",
    examples: ["Theme park", "Big toy", "Special day out"]
  }
}

// Helper function to get random rewards by category
export const getRandomRewards = (category, count = 5) => {
  const categoryRewards = rewardTemplates[category] || []
  const shuffled = [...categoryRewards].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

// Helper function to get age-appropriate rewards
export const getAgeAppropriateRewards = (age) => {
  if (age <= 5) return getRandomRewards('food', 2).concat(getRandomRewards('privileges', 2), getRandomRewards('creative', 2))
  if (age <= 8) return getRandomRewards('activities', 2).concat(getRandomRewards('social', 2), getRandomRewards('shopping', 2))
  if (age <= 12) return getRandomRewards('screenTime', 2).concat(getRandomRewards('physical', 2), getRandomRewards('events', 2))
  return getRandomRewards('privileges', 2).concat(getRandomRewards('shopping', 2), getRandomRewards('events', 2))
}

// Helper function to get rewards by point range
export const getRewardsByPointRange = (minPoints, maxPoints) => {
  const allRewards = Object.values(rewardTemplates).flat()
  return allRewards.filter(reward => 
    reward.points >= minPoints && reward.points <= maxPoints
  )
}

// Helper function to get rewards by category name
export const getRewardsByCategory = (categoryName) => {
  const categoryConfig = rewardCategories[categoryName]
  if (!categoryConfig) return []
  
  return getRewardsByPointRange(
    categoryConfig.pointRange[0], 
    categoryConfig.pointRange[1]
  )
}

export default rewardTemplates